import { render, staticRenderFns } from "./DocumentGroupAddEditModal.vue?vue&type=template&id=06557927&"
import script from "./DocumentGroupAddEditModal.vue?vue&type=script&lang=js&"
export * from "./DocumentGroupAddEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports